import { cn } from '../lib/cn.js'

/**
 * "Faixa de informação · sempre na base da peça" (guia). No app, é a barra de
 * horário/telefone no pé do cardápio e o rodapé de status da loja.
 */
export type InfoBandProps = {
  children: React.ReactNode
  tom?: 'preto' | 'laranja' | 'amarelo' | undefined
  className?: string | undefined
}

export function InfoBand({ children, tom = 'preto', className }: InfoBandProps) {
  return <div className={cn('du-faixa', `du-faixa--${tom}`, className)}>{children}</div>
}
